<template>
    <div class="main">
        <div class="header_margin">
            <span>
                <span style="width: 50px; vertical-align: middle;">
                    <router-link :to="{ path: '/Investigation/' + investigation.investigationId }" tag="a" class="fa fa-edit" style="font-size: 16px;"></router-link>
                </span>
                <span class="label">Investigation DBI No.</span>
                <span class="value">{{investigation.dbNumber}}</span>
            </span>
            <span v-if="investigation.currentWorkflowStatusId === 3350">
                <span class="value" style="color: red;">NOT ACCEPTED</span>
            </span>
        </div>
        <!-- <div>
            <span class="label">Activities</span>
            <span class="value">{{investigationTypes}}</span>
        </div> -->
        <div>
            <span class="label">Activities</span>
            <span class="value">
                <span
                    v-for="(type, index) in investigationTypes"
                    :key="index"
                    :class="{'red-text': type.investigationTypeDescription === 'EO 14156'}"
                >
                    {{ type.investigationTypeDescription }}<span v-if="index < investigationTypes.length - 1">, </span>
                </span>
            </span>
        </div>
        <div class="header_margin">
            <span class="label">Report Title</span>
            <span class="value">{{investigation.reportTitle}}</span>
        </div>
        <div v-show="invMigrationRefs.length > 0">
            <span class="label">Migrated References</span>
            <span class="value">
                <v-client-table style="display: inline-block; margin: auto; min-width: 50%;" :data="invMigrationRefs" :columns="gridInvMigrationRef.columns" :options="gridInvMigrationRef.options">
                </v-client-table>
            </span>
        </div>
    </div>
</template>

<script>
import loggingService from '../services/util/loggingService'
import { mapState } from 'vuex'
import roleService from '@/services/roleService.js'
import userService from '@/services/userService.js'
export default {
    name: 'investigationHeader',
    data: function () {
        return {
            isDebug: false,
            gridInvMigrationRef: {
                columns: ['investigationDbNumber', 'rcRevno', 'n9recId', 'acno'],
                tableData: [],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 5,
                    perPageValues: [10, 25, 50, 100],
                    headings: {
                        investigationDbNumber: 'DB Number',
                        rcRevno: 'Rev No',
                        n9recId: 'N9RecId',
                        acno: 'ACNO'
                    },
                    filterable: false
                }
            }
        }
    },
    props: {
        investigation: { default: () => {} },
        invMigrationRefs: { default: () => [] }
    },
    created () {
        loggingService.log(this.isDebug, 'investigationHeader', 'created')
    },
    mounted () {
        loggingService.log(this.isDebug, 'investigationHeader', 'mounted')
    },
    computed: {
        // compute current user info
        ...mapState({
            shpoUserDto: state => state.auth.shpoUserDto
        }),
        isConsultant: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.ConsultantOnlyRoleList)
        },
        investigationTypes: function () {
            return this.investigation.investigationTypeList || []
        }
    }
}
</script>


<style>
    .main {
        padding: 10px;
        margin-left: 10px;
        margin-right: 10px;
        margin-bottom: 10px;
        border: 1px solid #cccccc;
        border-radius: 4px;
        background-color: #f5f5f5;
    }
    .label {
        margin-right: 20px;
        color: #555555;
        font-weight: normal;
        vertical-align: top;
    }
    .value {
        margin-right: 20px;
        font-weight: bold;
    }
    .header_margin {
        margin-bottom: 5px;
    }
</style>



// WEBPACK FOOTER //
// InvestigationHeader.vue?5d8931aa